import Swipers from "./swiper";

document.addEventListener("DOMContentLoaded", function () {
    const swipers = new Swipers({});
    swipers.init();
});
